"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import FormatDate from "@/utils/FormatDate";

const EventCards = ({ events }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">

      {events.map((event) => {
        const {
          id,
          slug,
          titel,
          publish_date,
          description,
          cover,
          cover_thumbnail,
          updatedAt,
          images,
        } = event;

        const isVideo = cover?.mime?.includes("video");

        // 1️⃣ Video THUMBNAIL Priority
        let displayThumbnail = null;

        if (isVideo) {
          //▶ If cover_thumbnail exists → show it
          if (cover_thumbnail?.url) {
            displayThumbnail = cover_thumbnail.url;
          }
          else {
            //▶ Else fallback to first image
            displayThumbnail =
              images?.[0]?.formats?.medium?.url ||
              images?.[0]?.url ||
              "/fallback.jpg";
          }
        } else {

          displayThumbnail =
            cover?.url ||
            images?.[0]?.formats?.medium?.url ||
            images?.[0]?.url ||
            "/fallback.jpg";
        }

        // Short description
        const shortDescription = description?.[0]?.children?.[0]?.text || "";

        return (
          <div key={id} className="cursor-pointer overflow-hidden bg-white transition ">

            {/* IMAGE or THUMBNAIL */}
            <Link href={`/events/${slug}`}>
              <div className="relative w-full h-[230px] bg-gray-100 overflow-hidden">
                <Image
                  src={displayThumbnail}
                  alt={titel}
                  fill
                  sizes="(max-width: 768px) 100vw, 33vw"
                  className="object-contain transition-transform duration-500 hover:scale-105"
                />
              </div>
            </Link>

            {/* EVENT CONTENT */}
            <div className="my-4">
              {/* Category */}
              {event.event_category?.titel && (
                <span className="inline-block text-xs font-bold text-[#EB9100] bg-[#FFF0D7] p-2 mb-2  rounded capitalize">
                  {event.event_category.titel}
                </span>
              )}
              <Link href={`/events/${slug}`} >
                <h3 className="text-[18px] font-bold line-clamp-2 hover:text-blue-600">
                  {titel}
                </h3>
              </Link>

              <p className="mt-2 text-[14px] text-gray-600 line-clamp-2">
                {shortDescription}
              </p>
              <hr
                className="my-3 border-0 h-[1.5px]"
                style={{ backgroundColor: "#616777", opacity: 0.2 }}
              />
              <p className="mt-3 text-sm text-gray-500">{publish_date ? FormatDate(publish_date) : FormatDate(updatedAt)}</p>


            </div>
          </div>
        );
      })}

    </div>
  );
};

export default EventCards;